import { render, staticRenderFns } from "./CodeQA.vue?vue&type=template&id=123fcb9e&scoped=true&"
import script from "./CodeQA.vue?vue&type=script&lang=js&"
export * from "./CodeQA.vue?vue&type=script&lang=js&"
import style0 from "./CodeQA.vue?vue&type=style&index=0&id=123fcb9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123fcb9e",
  null
  
)

export default component.exports